module.exports = __webpack_public_path__ + "static/media/Pumpkaboo_gaussian2.7342a48a.png";